const countryData = {
  UnitedStates: {
    regionCode: "US",
    currencyCode: "USD",
    currencySymbol: "$",
    conversionRate: 0
  },
  Australia: {
    regionCode: "AU",
    currencyCode: "AUD",
    currencySymbol: "$",
    conversionRate: 1.5
  },
  Canada: {
    regionCode: "CA",
    currencyCode: "CAD",
    currencySymbol: "$",
    conversionRate: 1.5
  },
  Singapore: {
    regionCode: "SG",
    currencyCode: "SGD",
    currencySymbol: "$",
    conversionRate: 1.5
  },
  UAE: {
    regionCode: "AE",
    currencyCode: "AED",
    currencySymbol: "Dhs.",
    conversionRate: 1.5
  },
  UnitedKingdom: {
    regionCode: "GB",
    currencyCode: "GBP",
    currencySymbol: "£",
    conversionRate: 1.5
  }
};

function getCurrencySymbol(currencyCode) {
  for (const country in countryData) {
    if (countryData[country].currencyCode === currencyCode) {
      return countryData[country];
    }
  }
  return "Currency code not found";
}



////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


window.onWizzyScriptLoaded = function () {

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-search-results");
  replaceTemplate("wizzy-search-empty-results");
  replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-autocomplete-suggestions");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.swatch = [{"key":"product_Size"}];
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-main"];
      window.wizzyConfig.autocomplete.enabled = false;
      window.wizzyConfig.search.configs.general.behaviour = "search_as_you_type";
      payload.endpoints.common = "https://uranus-api.wizsearch.in";
      window.wizzyConfig.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.sort = [
          {
              "field": "relevance",
              "order": "asc"
          },
          {
              "field": "product_most-loved_sortOrder:float",
              "order": "asc"
          }
      ]

      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 2e3,
          mobile: 2e3
      };

      let currencyData = getCurrencySymbol(window.Shopify.currency.active);
      if(currencyData){
        window.wizzyConfig.store.currency.symbol = currencyData.currencySymbol;
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.swatch = [{"key":"product_Size"}];
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-main"];
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0;
      window.wizzyConfig.search.configs.general.minQueryLength=1;
      // window.wizzyConfig.common.isLazyInit = true;

      // if(window.document.documentElement.clientWidth < 768){
      //     window.wizzyConfig.autocomplete.enabled = false;
      //     window.wizzyConfig.search.configs.general.behaviour = "search_as_you_type";
      // }

      window.wizzyConfig.autocomplete.enabled = false;
      window.wizzyConfig.search.configs.general.behaviour = "search_as_you_type";
      payload.endpoints.common = "https://uranus-api.wizsearch.in";

      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 2e3,
          mobile: 2e3
      };

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")

      payload.forEach(product => {
        product.averageRating = "";
        product.numberOfReviews = "";
        product.bestSeller = false;
        product.customHandle = "";
        product.benefits = "";
        product.mustTry = false;
        product.limitedStock = false;
        product.winterSpecial = false;
        product.trending = false;
        if(product.attributes){
          product.attributes.forEach(attribute => {
            if(attribute.id === "product_badge_judgeme"){
              if(attribute.values[0].value[0]){
                const htmlReview = attribute.values[0].value[0];
                // console.log("htmlReview",htmlReview);

                const newHtmlReview = window.document.createElement("div");
                newHtmlReview.innerHTML = htmlReview;
                // console.log("newHtmlReview",newHtmlReview);

                const reviewBadge = newHtmlReview.querySelector('.jdgm-prev-badge');

                product.averageRating = reviewBadge ? reviewBadge.getAttribute('data-average-rating') : null;
                product.numberOfReviews = reviewBadge ? reviewBadge.getAttribute('data-number-of-reviews') : null;

                function formatReviewCount(reviewCount) {
                    let count = parseInt(reviewCount); // Convert the string to an integer
                    if (count > 1000) {
                        // Format the number to 'k+' if it's greater than 1000
                        let formattedCount = Math.floor(count / 1000); // Get the number in thousands
                        return `${formattedCount}k+`;
                    }
                    return count.toString(); // Return the number as a string if it's less than or equal to 1000
                }

                product.numberOfReviews = formatReviewCount(product.numberOfReviews);

                function formatRating(rating) {
                    let ratingValue = parseFloat(rating); // Convert the string to a float
                    if (ratingValue % 1 === 0) {
                        // If the value is an integer (no decimal part), return it as an integer
                        return ratingValue.toString(); // This will be the whole number as a string
                    } else {
                        // Otherwise, return the value as a float (removes trailing zero if present)
                        return ratingValue.toFixed(1); // This will remove unnecessary trailing zeros
                    }
                }

                product.averageRating = formatRating(product.averageRating);
                
                // console.log("Average Rating:", product.averageRating);
                // console.log("Number of Reviews:", product.numberOfReviews);
                
              }
            }
            if(attribute.id === "product_tags"){
              if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Best Seller")){
                product.bestSeller = true;
              }
            }
            if(attribute.id === "product_handle"){
              if(attribute.values[0].value[0]){
                product.customHandle = attribute.values[0].value[0];
              }
            }
            if(attribute.id === "product_usp_benefits_custom"){
              if(attribute.values[0].value[0]){
                product.benefits = attribute.values[0].value[0];
              }
            }
            if(attribute.id === "product_badges_custom"){
              if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Must Try")){
                product.mustTry = true;
                product.bestSeller = false;
              }
              if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Limited Stock")){
                product.limitedStock = true;
                product.bestSeller = false;
              }
              if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Winter Special")){
                product.winterSpecial = true;
                product.bestSeller = false;
              }
              if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("Trending")){
                product.trending = true;
                product.bestSeller = false;
              }
            }
          })
        }
      })

       payload.forEach(product => {
            if (product.price && product.price.endsWith(".00") && (product.price = product.price.slice(0, -3)),
            product.sellingPrice && product.sellingPrice.endsWith(".00") && (product.sellingPrice = product.sellingPrice.slice(0, -3)),
            product.discount) {
                product.discount.endsWith(".00") && (product.discount = product.discount.slice(0, -3));
                // var discountPrice = product.discount;
                // discountPrice && (product.discount = discountPrice.replace(/,/g, ""))
            }
        }
        );

      payload.forEach(product => {
        product.swatchAvailable = false;
        product.selectedVariants = "";
        if(product.swatches && product.swatches.length > 0){
          if(product.swatches[0].values && product.swatches[0].values.length>0){
            const swatchesAll = product.swatches[0].values;
            // console.log(swatchesAll);
            if(swatchesAll && swatchesAll.length>0){
              product.swatchAvailable = true;
              swatchesAll.forEach(item => {
                if(item.isSelected){
                  product.selectedVariants = item.value;
                }
              })
            }
          }
        }
      })

      payload.forEach(product => {
        if(product.customHandle === "amorearth-desi-cow-a2-ghee"){
          if(product.images.length > 1){
            product.mainImage = product.images[0];
          }
        }
        if(product.customHandle === "high-fibre-low-gluten-flour"){
          if(product.images.length > 1){
            product.mainImage = product.images[0];
          }
        }
        if(product.customHandle === "immunity-ehancing-herbal-mix-gooseberry"){
          if(product.images.length > 1){
            product.mainImage = product.images[0];
          }
        }
      })

      payload.forEach(product => {
        if(product.sellingPrice && !product.sellingPriceChanged){
          var sellingPrice = parseFloat(product.sellingPrice);
          var currencyData = getCurrencySymbol(window.Shopify.currency.active);
          sellingPrice = window.bucksCC.Currency.convert(sellingPrice, "USD",currencyData.currencyCode);
          sellingPrice = sellingPrice + ((sellingPrice * currencyData.conversionRate) / 100);
          sellingPrice = Math.ceil(sellingPrice);
          product.sellingPrice = sellingPrice.toString();
          product.sellingPriceChanged = true;
        }
        if(product.price && !product.priceChanged){
          var price = parseFloat(product.price);
          var currencyData = getCurrencySymbol(window.Shopify.currency.active);
          price = window.bucksCC.Currency.convert(price, "USD",currencyData.currencyCode);
          price = price + ((price * currencyData.conversionRate) / 100);
          price = Math.ceil(price);
          product.price = price.toString();
          product.priceChanged = true;
        }
        if(product.discount && !product.discountChanged){
          var discount = parseFloat(product.discount);
          var currencyData = getCurrencySymbol(window.Shopify.currency.active);
          discount = window.bucksCC.Currency.convert(discount, "USD",currencyData.currencyCode);
          // discount = discount + ((discount * currencyData.conversionRate) / 100);
          discount = Math.ceil(discount);
          product.discount = discount.toString();
          product.discountChanged = true;
        }
      })
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      payload.minQueryLength = 1;
      payload.minLastWordLength = 1;
      payload.sort = [];
      payload.sort = [
        {
            "field": "product_value_tags_wizzy_hero_product",
            "order": "desc"
        },
       {
          "field": "relevance",
          "order": "asc"
      }
      ]
      payload.swatch = [{"key":"product_Size"}];
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      
      return data;
    });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER");

      //  if(data.products){
      //   var newProductsId = [];
      //   if(data.products.length > 0){
      //     var allProducts = data.products;
      //     if(allProducts){
      //       // console.log("I got here wizzy");
      //       allProducts.forEach(product => {
      //         if(product.attributes){
      //           product.attributes.forEach(attribute => {
      //             if(attribute.id === "product_tags"){
      //               if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("BYOB")){
      //                 newProductsId.push(product.id);
      //                 // console.log("I got here wizzy")
      //               }
      //             }
      //           })
      //         }
      //       })
      //     }
      //     console.log(newProductsId," <==== newProductsId")
      //     data.products = data.products.filter(product => !newProductsId.includes(product.id));
      //   }
      // }
    
      return data;
    });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(data) {
      console.log(data, "<====PRODUCTS_CACHED_RESULTS_RENDERED");

     var queryHit = window.wizzyConfig.pageStore.searchedResponse.filters.q;
          console.log(queryHit);
    
          let hasNextPage = true;  // Track if there are more pages
          let nextPageCursor = null;  // Track the cursor for the next page
        
          // Function to fetch articles
          function fetchArticles(cursor = null) {
            // GraphQL query
            const query = `
              query {
                articles(first: 12, query: "${queryHit}", sortKey: RELEVANCE, after: ${cursor ? `"${cursor}"` : "null"}) {
                  pageInfo {
                    hasNextPage
                    hasPreviousPage
                  }
                  edges {
                    cursor
                    node {
                      id
                      title
                      image {
                        src
                      }
                      blog {
                        handle
                      }
                      handle
                      content
                      contentHtml
                      excerpt
                      excerptHtml
                      publishedAt
                      authorV2 {
                        name
                      }
                    }
                  }
                }
              }
            `;
        
            fetch('https://two-brothers-organic-farms-amorearth.myshopify.com/api/graphql', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'e3ceb279c2e787e12c0e36defcb71cf4', // Replace with your actual access token
              },
              body: JSON.stringify({
                query: query,
              }),
            })
            .then(response => response.json())
            .then(data => {
              // Log the entire response to inspect the structure
              console.log('API Response:', data);
        
              if (data && data.data && data.data.articles) {
                const blogList = document.querySelector('.wizzy-blog-list');
                
                // Loop through the edges array from the fetched data
                data.data.articles.edges.forEach(edge => {
                  const article = edge.node;
        
                  // Create the HTML structure for each article
                  const articleHtml = `
                    <div class="st-product-wrap">
                      <div class="st-product">
                        <figure class="st-product-media">
                          <a href="/blogs/food-health/${article.handle}" class="asdf">
                            <img src="${article.image.src}" alt="${article.title}">
                          </a>
                        </figure>
                        <div class="st-product-details">
                          <div class="st-product-date">
                            ${new Date(article.publishedAt).toLocaleDateString()}
                          </div>
                          <div class="st-product-name">
                            <a href="/blogs/food-health/${article.handle}">${article.title}</a>
                          </div>
                          <div class="st-product-author">
                            by ${article.authorV2.name}
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
                  
                  // Append the generated HTML to the .wizzy-blog-list container
                  blogList.innerHTML += articleHtml;
                });
        
                // Get the pagination info
                const pageInfo = data.data.articles.pageInfo;
        
                // If there's a next page, set up for the next fetch
                if (pageInfo.hasNextPage) {
                  nextPageCursor = data.data.articles.edges[data.data.articles.edges.length - 1].cursor;
                  hasNextPage = true;
                } else {
                  hasNextPage = false;
                }
        
                // Show the 'Load More' button only if there's a next page
                if (hasNextPage) {
                  document.getElementById('load-more').style.display = 'block';
                } else {
                  document.getElementById('load-more').style.display = 'none';
                }
              } else {
                console.error('Error: Unable to retrieve articles', data);
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        
          // Initial fetch when the page loads
          fetchArticles();
        
          // Event listener for the "Load More" button
          document.getElementById('load-more').addEventListener('click', () => {
            if (hasNextPage) {
              fetchArticles(nextPageCursor);
            }
          });

    //////////////////////////////////////////////////////////////////////////////////////////////////////////

        const tabs = document.querySelectorAll('.wizzy-st-single-tab'); // Get all the tabs
        const blogWrapper = document.querySelector('.wizzy-blog-wrapper'); // Get the blog wrapper
        const searchResultsWrapper = document.querySelector('.wizzy-search-results-wrapper'); // Get the search results wrapper
              
        // Loop through each tab and add click event listener
        tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                // Remove 'st-active' class from all tabs
                tabs.forEach(t => t.classList.remove('st-active'));
        
                // Add 'st-active' class to the clicked tab
                this.classList.add('st-active');
        
                // Check if the clicked tab is "Products" or "Blogs"
                if (this.classList.contains('products-tab')) {
                    // Show search results wrapper and hide blog wrapper
                    searchResultsWrapper.style.display = 'flex';
                    blogWrapper.style.display = 'none';
                } else if (this.classList.contains('blogs-tab')) {
                    // Show blog wrapper and hide search results wrapper
                    blogWrapper.style.display = 'block';
                    searchResultsWrapper.style.display = 'none';
                }
            });
        });
    
      return data;
    });

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")
      payload.inStock = [true,false];
      payload.minLastWordLength = 1;
      payload.minQueryLength = 1;

      if(payload.sort){
        console.log(payload.sort[0].field)
        if(payload.sort.length == 1 && payload.sort[0].field == "relevance") {
          payload.sort = [
            {
                "field": "product_value_tags_wizzy_hero_product",
                "order": "asc"
            },
            {
                "field": "relevance",
                "order": "asc"
            }
          ]
        }
      }
      // payload.sort = [
      //   {
      //       "field": "relevance",
      //       "order": "asc"
      //   },
      //   {
      //       "field": "product_Wizzy_Hero_tags:float",
      //       "order": "asc"
      //   }
      // ]

      const searchInput = document.querySelector('.st-search-bar .wizzy-search-input');

      if(searchInput){
        if (searchInput.value.length > 0) {
              const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
              if (autocomplete) {
                  autocomplete.style.display = 'none';
              }
          }

        // searchInput.addEventListener('click', function(event) {
        //     if (searchInput.value.length > 0) {
        //       event.preventDefault();
        //       event.stopImmediatePropagation();
        //       event.stopPropagation();
        //         const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
        //         if (autocomplete) {
        //             setTimeout(function() {
        //                   autocomplete.style.display = 'none';
        //               }, 200);
        //         }
        //     }
        // });
        
      }

      const searchInputDesktop = document.querySelector('.st-search-box-desktop .wizzy-search-input');

      if(searchInputDesktop){
        if (searchInputDesktop.value.length > 0) {
              const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
              if (autocomplete) {
                  autocomplete.style.display = 'none';
              }
          }
        
      }

      // Get the element by its ID
      var mainElement = document.getElementById('main');
      if (mainElement) {
          mainElement.style.display = 'none';
      }

      var wizzyMainElement = document.getElementById('wizzy-main');
      if (wizzyMainElement) {
          wizzyMainElement.style.display = 'block';
      }
        
        return payload;
      }
    );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");
      // payload.filters.inStock = [true,false];
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
    function (payload) {
      console.log(payload,"EMPTY_RESULTS_RENDERED");
      window.wizzyConfig.gridFilters.enabled = false;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      window.wizzyConfig.gridFilters.enabled = true;

      if(data.data.api === "search" || (data.data.api === "filter" && data.data.response.payload.filters.page === 1 && data.data.response.payload.filters.page!=="AUTOCOMPLETE_DEFAULT")){

          var queryHit = data.data.response.payload.filters.q;
          console.log(queryHit);
    
          let hasNextPage = true;  // Track if there are more pages
          let nextPageCursor = null;  // Track the cursor for the next page
        
          // Function to fetch articles
          function fetchArticles(cursor = null) {
            // GraphQL query
            const query = `
              query {
                articles(first: 12, query: "${queryHit}", sortKey: RELEVANCE, after: ${cursor ? `"${cursor}"` : "null"}) {
                  pageInfo {
                    hasNextPage
                    hasPreviousPage
                  }
                  edges {
                    cursor
                    node {
                      id
                      title
                      image {
                        src
                      }
                      blog {
                        handle
                      }
                      handle
                      content
                      contentHtml
                      excerpt
                      excerptHtml
                      publishedAt
                      authorV2 {
                        name
                      }
                    }
                  }
                }
              }
            `;
        
            fetch('https://two-brothers-organic-farms-amorearth.myshopify.com/api/graphql', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'e3ceb279c2e787e12c0e36defcb71cf4', // Replace with your actual access token
              },
              body: JSON.stringify({
                query: query,
              }),
            })
            .then(response => response.json())
            .then(data => {
              // Log the entire response to inspect the structure
              console.log('API Response:', data);
        
              if (data && data.data && data.data.articles) {
                const blogList = document.querySelector('.wizzy-blog-list');
                
                // Loop through the edges array from the fetched data
                data.data.articles.edges.forEach(edge => {
                  const article = edge.node;
        
                  // Create the HTML structure for each article
                  const articleHtml = `
                    <div class="st-product-wrap">
                      <div class="st-product">
                        <figure class="st-product-media">
                          <a href="/blogs/food-health/${article.handle}" class="asdf">
                            <img src="${article.image.src}" alt="${article.title}">
                          </a>
                        </figure>
                        <div class="st-product-details">
                          <div class="st-product-date">
                            ${new Date(article.publishedAt).toLocaleDateString()}
                          </div>
                          <div class="st-product-name">
                            <a href="/blogs/food-health/${article.handle}">${article.title}</a>
                          </div>
                          <div class="st-product-author">
                            by ${article.authorV2.name}
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
                  
                  // Append the generated HTML to the .wizzy-blog-list container
                  blogList.innerHTML += articleHtml;
                });
        
                // Get the pagination info
                const pageInfo = data.data.articles.pageInfo;
        
                // If there's a next page, set up for the next fetch
                if (pageInfo.hasNextPage) {
                  nextPageCursor = data.data.articles.edges[data.data.articles.edges.length - 1].cursor;
                  hasNextPage = true;
                } else {
                  hasNextPage = false;
                }
        
                // Show the 'Load More' button only if there's a next page
                if (hasNextPage) {
                  document.getElementById('load-more').style.display = 'block';
                } else {
                  document.getElementById('load-more').style.display = 'none';
                }
              } else {
                console.error('Error: Unable to retrieve articles', data);
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        
          // Initial fetch when the page loads
          fetchArticles();
        
          // Event listener for the "Load More" button
          document.getElementById('load-more').addEventListener('click', () => {
            if (hasNextPage) {
              fetchArticles(nextPageCursor);
            }
          });        
      }

     

      ///////////////////////////////////////////////////

      const tabs = document.querySelectorAll('.wizzy-st-single-tab'); // Get all the tabs
      const blogWrapper = document.querySelector('.wizzy-blog-wrapper'); // Get the blog wrapper
      const searchResultsWrapper = document.querySelector('.wizzy-search-results-wrapper'); // Get the search results wrapper
      const emptySearchWrapper = document.querySelector(".wizzy-empty-result-wrapper"); // get empty wrapper
            
      // Loop through each tab and add click event listener
      tabs.forEach(tab => {
          tab.addEventListener('click', function() {
              // Remove 'st-active' class from all tabs
              tabs.forEach(t => t.classList.remove('st-active'));
      
              // Add 'st-active' class to the clicked tab
              this.classList.add('st-active');
      
              // Check if the clicked tab is "Products" or "Blogs"
              if (this.classList.contains('products-tab')) {
                  // Show search results wrapper and hide blog wrapper
                  searchResultsWrapper.style.display = 'flex';
                  blogWrapper.style.display = 'none';
                  if(emptySearchWrapper){
                    emptySearchWrapper.style.display = 'flex';
                  }
              } else if (this.classList.contains('blogs-tab')) {
                  // Show blog wrapper and hide search results wrapper
                  blogWrapper.style.display = 'block';
                  searchResultsWrapper.style.display = 'none';
                  if(emptySearchWrapper){
                    emptySearchWrapper.style.display = 'none';
                  }
              }
          });
      });

      ///////////////////////////////////////////////////////////////////////////////////////////////////////

      
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};


/////////////////////////////////////////////

window.addEventListener('scroll', function() {
  if (document.body) { // Check if the body exists
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / documentHeight) * 100;

    if (scrollPercentage >= 1) {
      document.body.classList.add('wizzy-scrolled'); // Add your class here
    } else {
      document.body.classList.remove('wizzy-scrolled'); // Optionally, remove class when scrolling back above 1%
    }
  }
});

/////////////////////////////////////////////////


const searchInput = document.querySelector('.st-search-box.wizzy-search-input');

if (searchInput && document.body) { // Ensure both the input and body exist
  searchInput.addEventListener('focus', function() {
    document.body.classList.add('input-focused'); // Add class when input is focused
  });

  searchInput.addEventListener('click', function() {
    document.body.classList.add('input-focused'); // Add class when input is clicked
  });

  searchInput.addEventListener('blur', function() {
    document.body.classList.remove('input-focused'); // Remove class when input loses focus
  });
}


////////////////////////////////////////////////////////


// const closeButton = document.querySelector('.wizzy-autocomple-closebtn');
// const autocompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper');

// if (closeButton && autocompleteWrapper) {
//     closeButton.addEventListener('click', function() {
//         autocompleteWrapper.style.display = 'none';
//     });
// }

///////////////////////////////////////////////////////////

// Check if the form is available before adding the event listener
var searchForm = document.getElementById('wizzySearchForm-Mobile');
if (searchForm) {
    searchForm.addEventListener('submit', function() {
        var autocompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper'); // Replace with your actual class or ID
        if (autocompleteWrapper) {
            autocompleteWrapper.style.display = 'none';
        }
    });
}

///////////////////////////////////////////////////////////////

const searchInputWizz = document.querySelector('.st-search-bar .wizzy-search-input');

if(searchInputWizz){
  searchInputWizz.addEventListener('click', function(event) {
      if (searchInputWizz.value.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
          const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
          if (autocomplete) {
              setTimeout(function() {
                    autocomplete.style.display = 'none';
                }, 200);
          }
      }
  });
}

///////////////////////////////////////////////////////////////

const searchInputWizzDestktop = document.querySelector('.st-search-box-desktop .wizzy-search-input');

if(searchInputWizzDestktop){
  searchInputWizzDestktop.addEventListener('click', function(event) {
      if (searchInputWizzDestktop.value.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
          const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
          if (autocomplete) {
              setTimeout(function() {
                    autocomplete.style.display = 'none';
                }, 200);
          }
      }
  });
}


////////////////////////////////////////////////////////////////////


// Get the close button element
const closeButtonSearch = document.querySelector('.st-search-box-desktop span.input-close-btn');

if(closeButtonSearch){
  closeButtonSearch.addEventListener('click', function() {
      const searchInputDesktop = document.querySelector('.st-search-box-desktop .wizzy-search-input');
      if (searchInputDesktop) {
          searchInputDesktop.value = '';
        // $(searchInputDesktop).trigger("keyup");
        // var event = new KeyboardEvent('keyup', {
        //     bubbles: true,
        //     key: 'Enter',
        //   });
        // searchInputDesktop.dispatchEvent(event);
      }
  });
}

const closeButtonSearchMobile = document.querySelector('.st-search-bar span.input-close-btn');

if(closeButtonSearchMobile){
  closeButtonSearchMobile.addEventListener('click', function() {
      const searchInputMobile = document.querySelector('.st-search-bar .wizzy-search-input');
      if (searchInputMobile) {
          searchInputMobile.value = '';
      }
  });
}

///////////////////////////////////////////////////////////////////////////////////

if(window.document.documentElement.clientWidth < 768){
  var wizzyInputMobile = document.querySelector('.st-search-bar .wizzy-search-input');

  if(wizzyInputMobile){
      wizzyInputMobile.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();  // Prevent form submission (if any)
        this.blur();         // Removes focus from the input field
      }
    });
  }
}

//////////////////////////////////////////////////////////////////

// Function to detect URL change
function onUrlChange() {
  // console.log('URL changed to:', window.location.href);

  let currentUrl = window.location.href
  
  // if (currentUrl.includes('https://twobrothersfood.com/products/')) {
  //   // console.log('URL includes: https://twobrothersfood.com/products/');
  //   function getTimeout() {
  //     return window.document.documentElement.clientWidth <= 768 ? 200 : 100; // 768px as the breakpoint for mobile
  //   }
    
  //   setTimeout(function() {
  //     var flickitySlider = document.querySelector('.flickity-slider');
      
  //     if (flickitySlider && !flickitySlider.hasChildNodes()) {
  //       var flickityViewport = document.querySelector('.flickity-viewport');
  //       if (flickityViewport) {
  //         flickityViewport.remove();
  //       }
  //     }
  //   }, getTimeout()); // Use dynamic timeout based on device type
  // }

  if(!currentUrl.includes('/pages/search')){
    
    // Get the element with id 'wizzy-main'
    var wizzyMainElementNew = document.getElementById('wizzy-main');
    if (wizzyMainElementNew) {
        wizzyMainElementNew.style.display = 'none';
    }
    
    // Get the element with id 'main'
    var mainElementNew = document.getElementById('main');
    if (mainElementNew) {
        mainElementNew.style.display = 'block';
    }

  }
  
}

// Listen for popstate events (back/forward navigation and pushState/replaceState)
window.addEventListener('popstate', onUrlChange);

// Monitor the URL when pushState() or replaceState() is called by wrapping these methods
const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;

history.pushState = function(state, title, url) {
  // console.log('pushState called:', url);
  originalPushState.apply(history, arguments);
  onUrlChange();  // Trigger URL change detection
};